// ════════════════════════════════════════════════════════════════════════
//  „So sieht es das Kind“
//
//  Die riskanteste Änderung der Redaktion ist der Übungstext, und sie hatte
//  bisher außer der Prüfung keine Rückmeldung: ob eine Zeile für ein Kind der
//  dritten Klasse zu lang ist oder ob die eingefärbten Tasten Sinn ergeben,
//  stand nirgends.
//
//  Bewusst nur das Bild, ohne Tipp-Engine. Wer hier üben könnte, würde die
//  Vorschau für die Lern-App halten – und ihre Abweichungen für Fehler der App.
//
//  Farben kommen aus dem Bundle (Finger) und aus @otto/design, nirgends von
//  hier: eine App, die eine Farbe selbst erfindet, baut den Rückschritt wieder
//  ein, den es schon einmal gab.
// ════════════════════════════════════════════════════════════════════════

import { fingerIndex, type Bundle, type Lesson, type Stage } from "@otto/lehrgang";
import own from "./preview.module.css";

export function StagePreview({
  bundle,
  lesson,
  stage,
}: {
  bundle: Bundle;
  lesson: Lesson;
  stage: Stage;
}) {
  const fingers = fingerIndex(bundle);
  const lessonKeys = new Set(lesson.keys);
  const homeRow = new Map(bundle.keyboard.homeRow.map((h) => [h.key, h.color]));

  return (
    <div className={own.frame} aria-label="Vorschau">
      <p className={own.hint}>{stage.hint || "…"}</p>
      <p className={own.text}>{stage.text || "…"}</p>

      <div className={own.keyboard}>
        {bundle.keyboard.rows.map((row) => (
          <div key={row.id} className={own.row}>
            {row.keys.map((key, j) => {
              // Gelernte Tasten tragen die Farbe ihres Fingers, ungelernte
              // bleiben grau – genau wie in der Lern-App.
              const known = lessonKeys.has(key);
              const color = fingers.get(key)?.color;
              return (
                <span
                  key={`${key}-${j}`}
                  className={`${own.key} ${key === " " ? own.space : ""} ${known ? own.keyOn : ""}`}
                  style={known && color ? { background: color } : undefined}
                >
                  {key === " " ? "Leertaste" : key}
                  {homeRow.has(key) && (
                    <span
                      className={own.spot}
                      style={{ background: homeRow.get(key) }}
                      aria-hidden="true"
                    />
                  )}
                </span>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}
